import { useEffect, useState } from 'react';
import { WeaverLoading } from 'Components';
import withDetailsContainer from './withDetailsContainer';
import {
  getProjectData,
  getAttributeKeyLabel,
  getMemberKey,
  getNodeLabel,
  getRelationkeyLabel,
} from 'Services/WeaverUtils';
import { Tooltip } from 'antd';
import { relationAttributesRenderer } from './shared';

const RelationNodeDetails = ({ data }) => {
  const [item, setItem] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRelationDetails = async () => {
      setLoading(true);

      const relationQuery = new Weaver.Query()
        .restrict([data.wvrId])
        .withRelations()
        .selectOut(getMemberKey());

      if (data.graph) {
        relationQuery.inGraph(data.graph);
      }

      const attributes = _.get(getProjectData(), 'relationAttributes', []);
      attributes.forEach(({ relKey }) => {
        relationQuery.selectOut(relKey, getMemberKey());
      });

      const relNode = await relationQuery.first();

      setItem(relNode);
      setLoading(false);
    };

    fetchRelationDetails();
  }, [data]);

  if (loading) {
    return <WeaverLoading style={{ margin: '33%' }} />;
  }

  const Details = withDetailsContainer(item, { nodeIsEditable: true });

  const detailsData = [
    ..._.chain(item.attributes())
      .map((val, key) => ({
        key,
        label: (
          <Tooltip title={key}>
            {_.truncate(getAttributeKeyLabel(key), { length: 25 })}
          </Tooltip>
        ),
        value: val,
      }))
      .sortBy('key')
      .value(),
    {
      key: 'from',
      label: 'From',
      value: getNodeLabel(item.fromNode),
      rowIsEditable: false,
    },
    {
      key: 'to',
      label: 'To',
      value: getNodeLabel(item.toNode),
      rowIsEditable: false,
    },
    {
      key: 'key',
      label: 'Key',
      value: getRelationkeyLabel(item.key, item.nodeId),
    },
    ...relationAttributesRenderer(item),
  ];

  return <Details>{detailsData}</Details>;
};

export default RelationNodeDetails;
